import { ActivityService } from './shared/activity.service';
import { ConfigRefineTasks, FlowMode, HelperFlowService } from './../services/helper-flow.service';
import { NotifierService } from './../services/notifier.service';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Component, OnInit, Input, AfterViewInit, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import {
  Actividad,
  Const,
  ConfigTask,
  CssStatus,
  Tarea,
  ActividadBase
} from '@app/shared';
import { isUndefined } from 'lodash';
import { ToastrService } from 'ngx-toastr';


import { AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';

// Lista de estados para la actividad
const cssStatus = Const.CSS_STATUS;
const status = {
  finalizado: cssStatus.finished,
  pendiente: cssStatus.pending,
  inactivo: cssStatus.inactive
};
type typeNotification = 'newActivity' | 'editActivity' | 'removeActivity' | 'newTask' | 'editActivityUtilities';

@Component({
  selector: 'iw-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
  providers: [ActivityService]
})
export class ActivityComponent implements OnInit, AfterViewInit, OnDestroy {
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess = 'process';
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @Input() isDesignTask = 'compact';
  // Id del tramite actual
  @Input() idTramite: number;
  // Determina si esta actividad pertenece a un trámite por default o una instancia
  @Input() belongsToInstance = true;
  // Determina si es la primer actividad activa
  @Input() isFirstActiveActivity = false;
  // Determina si la tarea es de un flujo para asociacion externa a una tarea
  @Input() externalAssociation = false;
  // Contiene el encabezado del flujo
  @Input() headerFlow: TemplateRef<any>;
  // define cuando es una actividad de utilitarios y debe mostar las opciones de las tareas y activades 
  @Input() utilitys = false;
  // Actividad actual
  @Input()
  set activity(v: Actividad) {
    // Validar si el estado coincide con una key de "states"
    if (status.hasOwnProperty(v.actividad_estado.nombre)) {
      this._status = status[v.actividad_estado.nombre];
    } else {
      this._status = status.pendiente;
    }
    // Si es la ultima actividad de un flujo de una instancia,
    // no se colapsan las tareas.
    // if (this.belongsToInstance) {
    //   this.isCollapsedTasks = v.meta.isLast ? false : true;
    // }
    // if (v.actividad_estado && v.actividad_estado.nombre === Const.STATUS_ACTIVITY.pending) {
    //   this.isCollapsedTasks = false;
    // }
    this.tasks = this.hfs.refineTasks(v, this.configRefineTasks);
    this._actividad = v;
  }
  get activity() {
    return this._actividad;
  }
  // Estado de la actividad
  get status() {
    return this._status;
  }

  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
    btnUtility: false
  };
  // Define si se relaiza las limitaciones para generico o no
  @Input() isGeneric = false;

  // get tasks() {
  //   return this.hfs.refineTasks(this.activity, this.configRefineTasks);
  // }
  // Determina si se esta realizando alguna petición al backend
  @Input() isLoading = false;
  // Oculta el componente del fantasma
  @Input() ghostHidden = 0;
  // Configuración para la refinación de las tareas
  @Input() configRefineTasks: Partial<ConfigRefineTasks> = {};
  // Configuración global de la tarea
  @Input() configTask: Partial<ConfigTask> = {};
  // Determina el comportamiento de la actividad con respecto al flujo
  @Input() flowMode: FlowMode = 'normal';
  // Determina la instancia de donde se esta ejecutando el flujo
  @Input() typeProcessInstance: string;
  // Muestra las tareas
  isCollapsedTasks = false;
  // Define cuando debe ocultar la tarea fantasma
  @Input() hiddenTaskGhost = false;
  // Contiene informacion que se desee compartir en caso de dar click a la tarea
  @Input() sharedData: any;
  // Tareas refinadas
  tasks: Tarea[];
  // Entrada de estados de las actividades
  @Input() ActivityStatus: ActividadBase[];
  // Indica al padre que se ha cambiado el estado de la actividad para que recargue el flujo
  @Output() refreshActivity = new EventEmitter<boolean>();
  // Define cuando mostrar el dropdown de utilitariosActivity(actividad)
  click = false;
  private _status: CssStatus;
  private _actividad: Actividad;
  // Controla si se muestra las tareas asociadas
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private ns: NotifierService,
    private hfs: HelperFlowService,
    private sts: ScrollToService,
    private as: AuthenticationService,
    private ads: ActivityService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    if (!this.belongsToInstance) {
      this.activateAction.created = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.created,
      );
      this.activateAction.update = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.update,
      );
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.delete,
      );
    } else if (this.utilitys) {
      this.activateAction.btnUtility = this.as.confirmPermission(
        Const.types_permissions.administrationUtilities,
        Const.types_action_permissions.btnActivityUtilitys,
      );

    }
  }

  ngAfterViewInit() {
    // Mover el scroll a la primer actividad activa
    if (this.isFirstActiveActivity) {
      this.sts.scrollTo({
        target: 'isFirstActivityActive'
      } as ScrollToConfigOptions);
    }
  }


  /**
   * Define cuando mostrar el selector de cambio de estado de la actividad
   *
   * @memberof ActivityComponent
   */
  utilitariosActivityClick() {
    if (this.activateAction.btnUtility) {
      this.click = true;
    } else {
      this.toastr.warning('No tienes permisos para realizar esta acción', 'Acceso denegado');
    }
  }

  utilitariosActivityUpdate(e: ActividadBase) {
    this.activity.actividad_estado = e;
    this.ads.ActivityUpdate(this.activity);
    this.notifyFlow('editActivityUtilities');
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Valida si se puede mostrar una determinada tarea en el flujo.
   *
   * @param {Tarea} task
   * @returns {boolean}
   * @memberof ActivityComponent
   */
  showTask(task: Tarea): boolean {
    let res = true;
    const fbrs = this.configTask.filterByRootStatus;
    if (!isUndefined(fbrs)) {
      res = task.activo === fbrs ? true : false;
    }
    return res;
  }

  /**
   * Genera una notificación al componente encargado del flujo
   * para que este inicie un proceso de la actividad o tarea.
   *
   * @memberof ActivityComponent
   */
  notifyFlow(type: typeNotification) {
    let data = {};
    let deactivate = false;
    let other = '';
    switch (type) {
      // Nueva actividad
      case 'newActivity':
        deactivate = this.belongsToInstance ? true : false;
        data = {
          nextOrderCreateActivity: !this.activity.meta.isLast ? this.activity.orden + 1 : 0
        };
        break;
      // Actualizar la actividad
      case 'editActivity':
        deactivate = this.belongsToInstance ? true : false;
        data = {
          activity: this.activity
        };
        if (this.flowMode === 'etapas') {
          deactivate = false;
          other = 'selectActivity'
        }
        break;
      // Actualizar la actividad
      case 'editActivityUtilities':
        deactivate = false;
        data = {
          activity: this.activity
        };
        break;
      // Eliminar la actividad
      case 'removeActivity':
        deactivate = this.belongsToInstance ? true : false;
        data = {
          activity: this.activity
        };
        break;
      // Nueva tarea
      case 'newTask':
        deactivate = this.belongsToInstance ? true : false;
        data = {
          activity: this.activity
        };
        break;
    }
    // Notificar evento click al padre
    if (!deactivate) {
      this.ns.set({
        source: 'activity',
        eventTriggered: 'click',
        action: this.flowMode === 'etapas' ? other : type,
        instance: this.typeProcess,
        data: data
      });
      this.refreshActivity.emit(true);
    }
  }

  /**
   *Refresca el flujo cuando hay reasignación
   *
   * @param {boolean} data
   * @memberof ActivityComponent
   */
  validReassign(data: boolean) {
    if (data) {
      this.refreshActivity.emit(true);
    }
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/shared/activity/activity.component.ts